export default '/build/1167c36c.png'